import { render } from "./EventsList.vue?vue&type=template&id=7bcf12f4"
import script from "./EventsList.vue?vue&type=script&lang=js"
export * from "./EventsList.vue?vue&type=script&lang=js"

import "./EventsList.vue?vue&type=style&index=0&id=7bcf12f4&lang=scss"
script.render = render

export default script